// Desired order
export const PROJECT_STAGE_STATUS_ORDER = [
  'New',
  'In Progress',
  'Active',
  'Completed',
  'Hold',
  'Cancelled',
];
